import React from 'react';
import { Skeleton } from '@mui/material';

const PersonalInformationLoader = () => (
  <Skeleton
    sx={{ width: '100%', height: '400px' }}
  />
);

export default PersonalInformationLoader;
